import { useLocation } from "react-router-dom";
import qs from "qs";

export const useNewsPortalPreview = () => {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  return Object.keys(query).includes("newsPortalPreview");
};
